import { AutogenLayoutLbReasonsPanel } from "./autogen/AutogenLayoutLbReasonsPanel";

export class LbReasonsPanel extends AutogenLayoutLbReasonsPanel { }
